export default __webpack_public_path__ + "static/juice-5f2d052231cf615ca6e9ec9b650d83a6.png";